import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image";
import useResponsive from '../../hooks/useResponsive';
import ServicesList from '../ServicesList/ServicesList';
import Content from '../UI/Content/Content';
import Icon from '../UI/Icon/Icon';
import Link from '../UI/Link/Link';
import { ShareLinks } from '../UI/Social/Social';
import Type from '../UI/Type/Type';
import * as styles from './ArticleBody.module.scss';

const ArticleBody = ({
  body,
  share,
  author,
  tags,
  services,
  prevPage,
  nextPage,
}) => {
  const { isMedium } = useResponsive();
  const { avatar } = author.userAvatar;

  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <Content items={body} allowBreakout />

        <aside className={styles.author}>
          {avatar && (
            <GatsbyImage
              image={avatar.localFile?.childImageSharp?.gatsbyImageData}
              className={styles.authorImg} />
          )}
          <div className={styles.authorBody}>
            <h2 className={styles.authorName}>
              By <Link to={author.uri}>{author.name}</Link>
            </h2>
            <p className={styles.authorDesc}>{author.description}</p>
          </div>
        </aside>

        {!!tags?.length && (
          <>
            <Type.MetaHeading as="h2">Tagged under</Type.MetaHeading>
            <ul className={styles.tags}>
              {tags?.map(({ id, name, uri }) => {
                return (
                  <li key={id}>
                    <Link className={styles.tag} to={uri}>
                      <Icon name="tag" />
                      {name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </>
        )}

        {services && (
          <>
            <Type.MetaHeading>Related service(s)</Type.MetaHeading>
            <ServicesList nodes={services} />
          </>
        )}
      </div>
      <div className={styles.aside1}>
        <div className={styles.sticky}>
          <ShareLinks isVertical={isMedium} {...share} />
        </div>
      </div>
      <div className={styles.aside2}>
        <div className={styles.sticky}>
          <ul className={styles.nav}>
            {prevPage && (
              <li>
                <Link to={prevPage.uri}>
                  <Icon name="arrow-left" />
                </Link>
              </li>
            )}

            {nextPage && (
              <li>
                <Link to={nextPage.uri}>
                  <Icon name="arrow-right" />
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ArticleBody;
